import { getDetectedDisplayLocale, getDisplayLocale } from './displayLocale';

function toDate(value: string | Date): Date | null {
    const d = value instanceof Date ? value : new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

/** Unambiguous calendar date, e.g. "6 Aug 2026" (en-GB) or "Aug 6, 2026" (en-US). */
export function formatDisplayDate(
    value: string | Date | null | undefined,
    locale = getDetectedDisplayLocale()
): string {
    if (!value) return '';
    const d = toDate(value);
    if (!d) return '';
    return d.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
    });
}

/** Calendar date and time for user-facing copy. */
export function formatDisplayDateTime(
    value: string | Date | null | undefined,
    locale = getDetectedDisplayLocale()
): string {
    if (!value) return '';
    const d = toDate(value);
    if (!d) return '';
    return d.toLocaleString(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
}

export { getDisplayLocale };
